import getLocationRouterSelect from 'modules/router/selectors/get-location'
import { createSelector } from 'reselect'
import getRouteAndMatchRouteUtil from 'modules/routes/utils/get-route-and-match'

const getRouteAndMatchRouterSelect = createSelector(
  getLocationRouterSelect,
  /**
   * @param location
   * @return {RouteMatch}
   */
  (location) => {
    return getRouteAndMatchRouteUtil(location.pathname)
  }
)

export default getRouteAndMatchRouterSelect
